import CglyticsTeaser from './CglyticsTeaser'

export default CglyticsTeaser
